// extracted by mini-css-extract-plugin
export default {"mainContainer":"styles_mainContainer__J8zhr","container":"styles_container__xw4AZ","hintText":"styles_hintText__jjPgM","warningText":"styles_warningText__AQPH7"};